export class Newsletter {
  constructor(section) {
    this.section = section;
    this.listId = section.dataset.listId;
    this.source = section.dataset.source;
    this.form = section.querySelector('form');
    this.klaviyoListId = section.dataset.listId;
    this.email = section.querySelector('input[type="email"]');
    this.companyId = 'PbvgDc'

    if (this.klaviyoListId) {
      this.form.addEventListener('submit', this.sendForm.bind(this));
    } else {
      return console.error('Klaviyo form id not found.');
    }
  }

  formData() {
    return {
      method: 'POST',
      headers: {revision: '2024-02-15', 'content-type': 'application/json'},
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: this.source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email:  this.email ?  this.email.value : '',
                }
              }
            }
          },
          relationships: {list: {data: {type: 'list', id: this.klaviyoListId}}}
        }
      })
    };
  }

  showMessage(type) {
    this.section.querySelectorAll('.form-message')?.forEach(item => item.classList.add('hide'));
    this.section.querySelector('.form-message__' + type).classList.remove('hide');

    setTimeout(() => {
      this.section.querySelector('.form-message__' + type).classList.add('hide');
    }, 10000)
  }

  sendForm(event) {
    event.preventDefault();
    const _this = this;
    const input = this.section.querySelector('input[name="email"]');

    console.log(this.emailValidation())

    if (this.emailValidation()) {
      fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`, this.formData())
        .then(response => {
          if (response.status === 202) {
            input.value = '';
            _this.showMessage("success");
          } else {
            _this.showMessage("error");
          }
        })
        .catch(err => {console.error(err); _this.showMessage("error")});

    } else {
      this.showMessage("error-email");
    }
  }

  emailValidation() {
    if (this.email) {
      const emailValue = this.email.value;
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const result = re.test(emailValue);

      return result && result !== ''
    } else {
      return true
    }
  }
}
